import React from "react";
import SEOLandingPage from "./SEOLandingPage";

const UnitConverterAndroid: React.FC = () => (
  <SEOLandingPage
    title="Unit Converter for Android — Convert 50+ Unit Types Instantly | Cosmovex"
    metaDescription="Unit Converter for Android. Convert length, weight, temperature, volume, speed, and 50+ unit types instantly. Offline, fast, and completely free."
    ogTitle="Unit Converter for Android"
    h1="Unit Converter for Android"
    intro="Convert any unit in seconds. Length, weight, temperature, volume, speed, pressure, energy, and 50+ more. Offline, instant, no ads, no internet required."
    paragraphs={[
      "Unit conversions come up all the time — kilometers to miles on a road trip, Celsius to Fahrenheit when cooking, kilograms to pounds for a recipe, or any of a hundred other conversions. Searching online takes time. Unit Converter puts instant conversions right in your pocket.",
      "Type a number and get the result instantly. Supports metric and imperial units, scientific notation, and decimal values. Whether you're converting 1.5 km to miles, 98.6°F to Celsius, or obscure engineering units, the app handles it without hesitation. Search for any unit by name — type 'km to miles' or just 'kilogram' and find what you need immediately.",
      "Covers every common unit category: length (meter, foot, mile, kilometer, inch), weight (kilogram, pound, ounce, gram), temperature (Celsius, Fahrenheit, Kelvin), volume (liter, gallon, cup, milliliter), speed (kmh, mph, m/s), pressure, power, energy, frequency, area, density, flow rate, viscosity, torque, and more.",
      "Works completely offline — no internet required, no server calls, no tracking. Your conversion data stays on your device. Dark theme for comfortable viewing at night. No ads, no clutter, just conversions. Simple, fast, reliable.",
    ]}
    features={[
      "50+ unit types covered",
      "Instant conversions",
      "Metric and imperial units",
      "Supports scientific notation",
      "Fast search by unit name",
      "Works completely offline",
      "Dark theme included",
      "No ads, no tracking",
      "Lightweight and fast",
      "Works with decimal values",
    ]}
    playStoreUrl="https://play.google.com/store/apps/details?id=com.cosmovex.unitvedit"
    icon="/images/unitvedit.png"
    appName="Unit Converter"
    accentColor="#A8720E"
    canonicalPath="/unit-converter-android"
  />
);

export default UnitConverterAndroid;
